module.exports = __webpack_public_path__ + "img/join3-4-h.8624a4ab.svg";